import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Document } from "../../models/document/document";
import {DocumentService} from "../../services/document.service";

@Component({
    selector: 'app-document-card',
    templateUrl: './document-card.component.html',
    styleUrls: ['./document-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DocumentCardComponent implements OnInit {

  @Input()
  document: Document;

  constructor(private documentService: DocumentService) {
  }

  ngOnInit() {
  }

  open() {
    this.documentService.download(this.document.fichier.id,this.document.fichier.token);
  }

}
